/* eslint-disable */

export default class BoxState {
  constructor() {
    this.box = {};
    this.products = [];
  }

  checkInsert(box, newProduct) {
    return this._fillBox({ ...box, shelves: [], remainingProducts: [] }, [
      ...this.products,
      {
        ...newProduct
      }
    ]);
  }

  currentStatus(box) {
    return this._fillBox({ ...box, shelves: [], remainingProducts: [] }, [
      ...this.products
    ]);
  }

  _fillBox(box, products) {
    products.forEach(product => {
      product.placed = false;
      if (product.rotated) {
        product.rotated = false;
        var temp = product.dim_x;
        product.dim_x = product.dim_y;
        product.dim_y = temp;
      }

      if (product.rotatable && product.dim_x > product.dim_y) {
        product.rotated = true;
        var temp = product.dim_x;
        product.dim_x = product.dim_y;
        product.dim_y = temp;
      } else {
        product.rotated = false;
      }
    });

    var currentShelfWidth = 0;
    products.sort(
      sort_by(
        {
          name: 'dim_y',
          primer: parseInt,
          reverse: true
        },
        {
          name: 'dim_x',
          primer: parseInt,
          reverse: true
        }
      )
    );

    productLoop: for (var i = 0; i < products.length; ++i) {
      var product = products[i];
      for (var index = 0; index < box.shelves.length; ++index) {
        var shelf = box.shelves[index];
        if (
          shelf.height - shelf.appendAt >= product.dim_y &&
          product.dim_x <= shelf.width
        ) {
          this._placeRectangle(box, shelf, product, index);

          continue productLoop;
        } else if (
          product.rotatable &&
          shelf.height - shelf.appendAt >= product.dim_x &&
          product.dim_y <= shelf.width
        ) {
          product.rotated = true;
          var temp = product.dim_y;
          product.dim_y = product.dim_x;
          product.dim_x = temp;
          this._placeRectangle(box, shelf, product, index);

          continue productLoop;
        }
      }

      if (
        currentShelfWidth + product.dim_x <= box.dim_x &&
        product.dim_y <= box.dim_y
      ) {
        currentShelfWidth = this._addShelf(box, product, currentShelfWidth);
      } else if (
        product.rotatable &&
        currentShelfWidth + product.dim_y <= box.dim_x &&
        product.dim_y <= box.dim_y
      ) {
        product.rotated = true;
        var temp = product.dim_y;
        product.dim_y = product.dim_x;
        product.dim_x = temp;
        currentShelfWidth = this._addShelf(box, product, currentShelfWidth);
      } else {
        box.remainingProducts.push(product);
      }
    }

    return box;
  }

  _placeRectangle(box, shelf, product, index) {
    product.placed = true;
    product.posX = shelf.posX;
    product.posY = shelf.posY + shelf.appendAt;
    shelf.products.push(product);
    shelf.appendAt += product.dim_y;

    if (product.dim_x < shelf.width) {
      box.shelves.splice(index, 0, {
        width: shelf.width - product.dim_x,
        height: product.dim_y,
        posX: product.posX + product.dim_x,
        posY: product.posY,
        appendAt: 0,
        products: []
      });
    }
  }

  _addShelf(box, product, currentShelfWidth) {
    var newShelf = {
      width: product.dim_x,
      height: box.dim_y,
      posX: currentShelfWidth,
      posY: 0,
      appendAt: 0,
      products: []
    };
    var newCurrentShelfWidth = currentShelfWidth + product.dim_x;
    product.placed = true;
    product.posX = newShelf.posX;
    product.posY = newShelf.posY + newShelf.appendAt;
    newShelf.products.push(product);
    newShelf.appendAt += product.dim_y;
    box.shelves.push(newShelf);

    return newCurrentShelfWidth;
  }
}

var sort_by;
(function() {
  // utility functions
  var default_cmp = function(a, b) {
      if (a == b) return 0;
      return a < b ? -1 : 1;
    },
    getCmpFunc = function(primer, reverse) {
      var cmp = default_cmp;
      if (primer) {
        cmp = function(a, b) {
          return default_cmp(primer(a), primer(b));
        };
      }
      if (reverse) {
        return function(a, b) {
          return -1 * cmp(a, b);
        };
      }
      return cmp;
    };

  // actual implementation
  sort_by = function() {
    var fields = [],
      n_fields = arguments.length,
      field,
      name,
      reverse,
      cmp;

    // preprocess sorting options
    for (var i = 0; i < n_fields; i++) {
      field = arguments[i];
      if (typeof field === 'string') {
        name = field;
        cmp = default_cmp;
      } else {
        name = field.name;
        cmp = getCmpFunc(field.primer, field.reverse);
      }
      fields.push({
        name: name,
        cmp: cmp
      });
    }

    return function(A, B) {
      var a, b, name, cmp, result;
      for (var i = 0, l = n_fields; i < l; i++) {
        result = 0;
        field = fields[i];
        name = field.name;
        cmp = field.cmp;

        result = cmp(A[name], B[name]);
        if (result !== 0) break;
      }
      return result;
    };
  };
})();
